import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import {EDIT} from '../../constants'
import * as Request from '../../request'
import * as LeadPostTypes from '../lead-posts/types'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export interface IndexChangeAction extends Redux.Action {
  dataIndex?: number
}

export const updateSelectedDate = (date: Types.SelectedDate) =>
  ({type: Constants.UPDATE_SELECTED_DATE, date})

export const fetchLeadPosts: any = (community: Types.SelectedCommunity, date: Types.SelectedDate) => {
 return IsActive.filteredDateFetchAction(Constants.FETCH_CALENDAR_POSTS,
   Constants.LEAD_POSTS_SERVER_RESOURCE)(community, date)
}

export const fetchLeadText: any = (community: Types.SelectedCommunity, date: Types.SelectedDate) => {
  return IsActive.filteredDateFetchAction(Constants.FETCH_CALENDAR_LEAD_TEXT,
    Constants.LEAD_TEXT_SERVER_RESOURCE)(community, date)
}

export const fetchPromotions: any = (community: Types.SelectedCommunity, date: Types.SelectedDate) => {
return IsActive.filteredDateFetchAction(Constants.FETCH_CALENDAR_PROMOTIONS,
  Constants.PROMOTIONS_SERVER_RESOURCE)(community, date)
}

export const dateChange = (date: Types.SelectedDate) =>
  ({type: Constants.CALENDAR_DATE_CHANGE, date})

export const update = (community: string, stateChange: IsActive.StateChange) => {
  let endpoint: string;
  switch (stateChange.props.dataItem.type) {
    case Constants.LEAD_TEXT:
      endpoint = Constants.LEAD_TEXT_SERVER_RESOURCE
      break;
    case Constants.PROMOTION:
      endpoint = Constants.PROMOTIONS_SERVER_RESOURCE
      break;
    default:
      endpoint = Constants.LEAD_POSTS_SERVER_RESOURCE
  }
  return (
   Request.requestActionCreator(Constants.UPDATE_CALENDAR)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${endpoint}/${community}/${stateChange.id}`,
  }))
}

export const [FormActions, FormConstants] = Form.createMaps(Constants.FEATURED_POST_FORM)

export const AddLeadTextModalActions = Form.createActionsMap(Constants.ADD_LEAD_TEXT_MODAL)

export interface EditPromotionAction extends Redux.Action {
  editType: string,
  promotion: Types.CCLeadContent,
}

export const editPromotionModal = (promotion: Types.CCLeadContent, editType: string): EditPromotionAction =>
  ({type: Constants.EDIT_PROMOTION, promotion, editType})

export type EnterEditActionCreator = (leadText: Types.CCLeadContent, editType?: string) =>
  Form.FormAction<Form.Fields<LeadPostTypes.FormFields>>

export const enterEdit: EnterEditActionCreator = (leadText: Types.CCLeadContent, editType: string = null) =>
  AddLeadTextModalActions[Form.ENTER](
    {
      ...Utils.asFormFields(leadText),
      type: editType || (leadText.editor_state ? Constants.GUI_EDITOR : Constants.RAW_EDITOR),
    },
  )

type EditModalAction = (leadPost: Types.CCLeadContent) => Form.EnterAction<LeadPostTypes.FormFields>

export const onEdit: EditModalAction = (leadContent: Types.CCLeadContent, editType: string = null) => {
  if (leadContent.type === Constants.LEAD_TEXT) {
    const finalLeadText = editType === EDIT ? leadContent : {
      ...leadContent,
      id: null,
    }
    return enterEdit(finalLeadText)
  } else if (leadContent.type === Constants.PROMOTION) {
      return editPromotionModal(leadContent, editType)
  } else {
      const finalLeadPost = editType === EDIT ? leadContent : {...leadContent, id: null}
      return FormActions[Form.ENTER](Utils.asFormFields(finalLeadPost))
  }
}

export const openSortModal = (sortType: string) => ({type: Constants.OPEN_SORT_MODAL, sortType})

export const toggleAddMenu = () => ({type: Constants.TOGGLE_ADD_MENU})
export const toggleSortMenu = () => ({type: Constants.TOGGLE_SORT_MENU})
export const toggleRankModal = () => ({type: Constants.TOGGLE_RANK_MODAL})
export const calendarEnterSort = () => ({
  options: {
    value: [
      {field: 'type', dir: 'asc'},
      {field: 'rank', dir: 'desc'},
    ],
  },
  type: Constants.CALENDAR_SORT_SORT_TABLE,
})

export const resetReorder = (community: Types.SelectedCommunity, leadPost: Types.CCLeadContent) => {
  return ({leadPost,  type: Constants.RESET_REORDERED_LEAD_POST})
}

export const saveReorder = (community: Types.SelectedCommunity,
                            leadPosts: Types.CCLeadContent,
                            selectedDate: Types.SelectedDate,
                            dispatch: Redux.Dispatch<Redux.Action>) => {
  return dispatch(Request.requestActionCreator(Constants.SAVE_REORDERED_LEAD_POST)({
    method: 'POST',
    payload: {lead_posts: leadPosts},
    url: `${Constants.LEAD_POSTS_SERVER_RESOURCE}/${community}/reorder/${selectedDate}`,
  }))
}



// WEBPACK FOOTER //
// ./src/pages/content-calendar/actions.ts